/**
 * Zooming settings for the diagram paper.
 */
export const Zoom = {
    Min: 0.2,
    Max: 2,
    Step: 10
};
/**
 * Default diagram name used in case the diagram name is not provided.
 */
export const defaultDiagramName = 'New Diagram';
